import React, { useEffect, useState } from 'react';

import { format as dateFnsFormat, formatRelative } from 'date-fns';
import { nb, sv } from 'date-fns/locale';
import { getMarket } from '../../i18n';

export type DateTimeFormats = 0 | 1 | 2;

export const dateTimeFormat = {
  DateTime: 0 as DateTimeFormats,
  DateTimeString: 1 as DateTimeFormats,
  RelativeFromNow: 2 as DateTimeFormats,

  format: (
    value: string | number | Date,
    format: DateTimeFormats | undefined,
    marketCode: string,
  ) => {
    const currentLocale = marketCode === 'NO' ? nb : sv;

    switch (format) {
      case dateTimeFormat.DateTimeString:
        return dateFnsFormat(new Date(value), "EEEE, d MMMM yyyy ', kl' HH:mm", {
          locale: currentLocale,
        });
      case dateTimeFormat.RelativeFromNow:
        return formatRelative(new Date(value), new Date(), { locale: currentLocale });
      case dateTimeFormat.DateTime:
        return dateFnsFormat(new Date(value), 'd MMMM HH:mm', { locale: currentLocale });
      default:
        return dateFnsFormat(new Date(value), 'yyyy-MM-dd HH:mm', { locale: currentLocale });
    }
  },
};

interface DateTimeProps {
  value: string | number | Date | null;
  format?: DateTimeFormats;
  className?: string;
}

const DateTime = ({ value, format, className }: DateTimeProps) => {
  const marketCode = getMarket().marketCode;
  const [dateTimeOutput, setDateTimeOutput] = useState<string | null>(null);
  useEffect(() => {
    if (value !== null) {
      setDateTimeOutput(dateTimeFormat.format(value, format, marketCode));
    }
  }, []);

  return dateTimeOutput ? <span className={className}>{dateTimeOutput}</span> : null;
};

export default DateTime;
